import { render, staticRenderFns } from "./CreateCustomDoc.vue?vue&type=template&id=90d4989a&scoped=true&"
import script from "./CreateCustomDoc.vue?vue&type=script&lang=js&"
export * from "./CreateCustomDoc.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomDoc.vue?vue&type=style&index=0&id=90d4989a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d4989a",
  null
  
)

export default component.exports